import styled from 'styled-components';
import {
  Spin,
} from 'antd';
import {
  COLOR_CV_6,
} from 'constants/colors';

export const StyledAntdSpinner = styled(Spin)`
  .ant-spin-dot-item {
    background-color: ${COLOR_CV_6}
  }
`;
